// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__1Sktk","load1":"Spinner_load1__2Hvgg"};